import React, { Fragment } from 'react';
import GoogleAnalytics from '../services/GoogleAnalytics';
import '../assets/css/PymeContactBox.scss';

const PymeContactBox = ({ pyme }) => {
  const {
    namePyme,
    imagePymeURL,
    streetPyme,
    streetPymeNumber,
    mailPyme,
    phonePyme,
    comune,
    regionName,
    virtualStore
  } = pyme;

  const gaCategory = process.env.REACT_APP_GA_CATEGORY;

  return (
    <Fragment>
      <div className="col-md-7 px-0">
        <div className="row px-0 py-0">
          <div className="col-12 px-0 py-0">
            <div className="pyme-contact-box float-md-right mb-3">
              {imagePymeURL !== null && typeof imagePymeURL !== 'undefined' ? (
                <img className="responsive" src={imagePymeURL} alt={namePyme} />
              ) : (
                <img
                  className="responsive"
                  src={'/img/big-default-img.svg'}
                  alt={namePyme}
                />
              )}
            </div>
            <h1 className="title pl-3 d-sm-none">{namePyme}</h1>
          </div>
          <div className="col-12 px-0 py-0 mt-5 d-none d-sm-block">
            <p style={{ fontSize:'18px' }} >
              <strong>Encuéntranos en:</strong>
            </p>
            { typeof virtualStore !== 'undefined' && virtualStore !== null && virtualStore !== '' && virtualStore === 'No' ? (
              <p style={{ fontSize:'18px' }} >
                <span style={{textTransform: 'capitalize'}}> { streetPyme + ", " + streetPymeNumber + ", " + comune + ". " + regionName} </span>
              </p>
            ) : (
              typeof virtualStore !== 'undefined' && virtualStore !== null && virtualStore !== '' && virtualStore === 'Yes' ? (
                <p style={{ fontSize:'18px' }} >
                  <span>En nuestra tienda virtual. {comune + ". " + regionName}</span>
                </p>
              ) : (
                <p style={{ fontSize:'18px' }} >
                  <span style={{textTransform: 'capitalize'}}> { streetPyme && streetPymeNumber ? streetPyme + ", " + streetPymeNumber + ", " + comune + ". " + regionName : comune + ". " + regionName} </span>
                </p>
              )
            ) }
            <p style={{ fontSize:'18px' }} >
              <strong>Correo electrónico: </strong>
              <a style={{ color: '#000000' }}
                 href={'mailto:' + mailPyme}
                 onClick={() =>
                   GoogleAnalytics.addEvent(
                     gaCategory,
                     'Click Correo Electrónico',
                     namePyme,
                     ''
                   )
                 }
                 target="_blank">
                {mailPyme}
              </a>
            </p>
            <p style={{ fontSize:'18px' }} >
              <strong>Teléfono: </strong>
              <a style={{ color: '#000000' }}
                 href={'tel:+56' + phonePyme}
                 onClick={() =>
                   GoogleAnalytics.addEvent(
                     gaCategory,
                     'Click Teléfono',
                     pyme.namePyme,
                     ''
                   )
                 }
                 target="_blank">
                {phonePyme}
              </a>
            </p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PymeContactBox;
